// extracted by mini-css-extract-plugin
export default {"envelope":"EnvelopeWithBox_envelope__0+mYX","tabTitleWrap":"EnvelopeWithBox_tabTitleWrap__fNmBL","envelopeAccent":"EnvelopeWithBox_envelopeAccent__0Deto"};